export enum UserField {
  login = "login",
  email = "email",
  fullName = "fullName",
  projects = "projects",
  role = "role",
  passwordExpirationDate = "passwordExpirationDate",
  lastActivity = "lastActivity",
  active = "active",
  deleted = "deleted"
}